<template>
  <v-container fluid pa-0 ma-0>
    <v-layout :id="'printable-pnx-schedule-' + schedule.tracking_id" hidden-screen-only>
      <v-container fill-height pa-0 ma-0>
        <v-layout row wrap>
<div style="margin: auto;font-size: 16px;line-height: 24px;font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;color: #555;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: left;">

<tr>
<td colspan="2" style="font-size: 12px;line-height: 12px;padding-bottom: 10px;text-align: center;">
<font color="#44A9E2">
<div v-if="schedule.account_receipt_header_1">{{ schedule.account_receipt_header_1 }}</div>
<div v-if="schedule.account_receipt_header_2">{{ schedule.account_receipt_header_2 }}</div>
<div v-if="schedule.account_receipt_header_3">{{ schedule.account_receipt_header_3 }}</div>
</font>
</td>
</tr>

<tr class="top">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td class="title" style="padding: 5px;vertical-align: top;padding-bottom: 20px;font-size: 45px;line-height: 45px;color: #333;">
<div v-if="schedule.account_logo">
<img :src="imageUrl + '/' + schedule.account_logo" style="width:100%; max-width:242px;" />
</div>
</td>
<td style="padding: 5px;vertical-align: top;text-align: right;padding-bottom: 20px;">
<h1>INSTALLMENT SCHEDULE</h1>
</td>
</tr>
</table>
</td>
</tr>

<tr class="information">
<td colspan="2" style="padding: 5px;vertical-align: top;">
<table style="width: 100%;line-height: inherit;text-align: left;">
<tr>
<td style="padding: 5px;vertical-align: top;padding-bottom: 40px;">
<h3>Please keep this schedule for your records.</h3><br>
<b><font color="#44A9E2">Billing Details</font></b><br>
<span v-if="schedule.billing_name">{{ schedule.billing_name }}<br></span>
<span v-if="schedule.billing_address">{{ schedule.billing_address }}<br></span>
<span v-if="schedule.billing_city || schedule.billing_state || schedule.billing_postal_code"><span v-if="schedule.billing_city">{{ schedule.billing_city }},</span> {{ schedule.billing_state }} {{ schedule.billing_postal_code }}<br></span>
<span v-if="schedule.billing_country">{{ schedule.billing_country }}</span>
</td>

<td style="padding: 5px;vertical-align: top;text-align: right;padding-bottom: 40px;">
<b><font color="#44A9E2">Merchant</font></b><br>
{{ schedule.account_name }}<br>
<span v-if="schedule.account_street_1">{{ schedule.account_street_1 }}<br></span>
<span v-if="schedule.account_street_2">{{ schedule.account_street_2 }}<br></span>
<span v-if="schedule.account_city">{{ schedule.account_city }}, {{ schedule.account_state }} {{ schedule.account_zip }}<br></span>
<span v-if="schedule.account_phone">{{ phone(schedule.account_phone) }}<br></span>
<span v-if="schedule.account_email">{{ schedule.account_email }}</span>
<br>&nbsp;<br>
<span v-if="schedule.customer_po">Customer PO: {{ schedule.customer_po }}<br></span>
<span v-if="schedule.custom_field_1">{{ schedule.custom_field_1 }}<br></span>
<span v-if="schedule.custom_field_2">{{ schedule.custom_field_2 }}<br></span>
<span v-if="schedule.custom_field_3">{{ schedule.custom_field_3 }}<br></span>
</td>
</tr>
</table>
</td>
</tr>

<tr>
<td colspan="2">
<table style="margin-left: auto; margin-right: auto;white-space:nowrap;width:90%;">

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Installment Amount:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ money(schedule.total_amount / 100) }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Payment Frequency:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ capitalize(schedule.recurring_type) }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Start Date:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ dateUtc(schedule.start) }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
End Date:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
<template v-if="schedule.end">{{ dateUtc(schedule.end) }}</template>
<template v-else>Ongoing</template>
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Status:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;text-transform: capitalize;">
{{ schedule.recurring_status }}
</td>
</tr>

<tr class="item">
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;width: 100%;">
Payment Method:
</td>
<td style="border-bottom: 1px solid #eee;padding: 5px;vertical-align: top;">
{{ schedule.request_type === 'ach' ? 'ACH' : 'Card' }} **** {{ schedule.last_four }}
</td>
</tr>

</table>
</td>
</tr>

<tr v-if="schedule.fee_amount">
<td colspan="2" style="font-size: 12px;line-height: 12px;padding-top: 10px;text-align: center;">
* Price Adjustment Fees have been added.
</td>
</tr>

</table>

<div style="bottom: 0;margin: 10px;position: absolute;width: 100%;">
<table cellpadding="0" cellspacing="0" style="width: 100%;line-height: inherit;text-align: center;">
<tr>
<td style="font-size: 12px;line-height: 12px;padding-top: 50px;text-align: center;">
<font color="#44A9E2">
<div v-if="schedule.account_receipt_footer_1">{{ schedule.account_receipt_footer_1 }}</div>
<div v-if="schedule.account_receipt_footer_2">{{ schedule.account_receipt_footer_2 }}</div>
<div v-if="schedule.account_receipt_footer_3">{{ schedule.account_receipt_footer_3 }}</div>
</font>
</td>
</tr>
</table>
</div>

</div>
        </v-layout>

      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { Printd } from 'printd'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      imageUrl: process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-dev-images.s3.us-west-2.amazonaws.com'
    }
  },

  props: {
    schedule: Object
  },

  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.imageUrl = process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-images.s3.us-west-2.amazonaws.com'
    }
  },

  methods: {
    print () {
      const printCallback = ({ launchPrint }) => {
        document.title = 'Installment Schedule'
        launchPrint()
      }
      const printd = new Printd()
      printd.print(document.getElementById('printable-pnx-schedule-' + this.schedule.tracking_id), [], [], printCallback)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pnxInstallments/SchedulePrint.vue